import { Controller } from "@hotwired/stimulus";
import { TypefacesOverview } from "../components/typefaces-overview";

export default class extends Controller {
  static values = {
    static: Boolean,
    colors: Object,
  };

  connect() {
    this.typefacesOverview = new TypefacesOverview(this.element, {
      animated: !this.staticValue,
      colors: this.colorsValue,
    });
    window.typefacesOverview = this.typefacesOverview;
  }

  disconnect() {
    this.typefacesOverview.destroy();
    if (window.typefacesOverview === this.typefacesOverview) {
      delete window.typefacesOverview;
    }
  }
}
